import { createPhpDatabase } from '../services/phpDataAdapter';

export const database = createPhpDatabase();
